import { render } from "./NewestNews.vue?vue&type=template&id=db911198&scoped=true"
const script = {}

import "./NewestNews.vue?vue&type=style&index=0&id=db911198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db911198"]])

export default __exports__